<template>
  <div id="app"  class="fillcontain" style=" background-color:aliceblue ">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',

  mounted () {
    // 根据不同路由跳转不同页面
    this.$route.path
    if( this.$route.path == '/'){
      console.log(this.$route.path )
      if (this._isMobile()) {
        console.log('手机端')
        this.$router.replace('/mini_login')
      } else {
        console.log('pc端')
        //this.$router.replace('/')
      }
    }
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>

<style lang="less">
html,body{
    height: 100%;
    width: 100%;
    // background-color: #F5F5F5;
}

.fillcontain{
    height: 100%;
    width: 100%;
    background-color:#f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/App.vue